import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useSnackbar } from "notistack";
import { invalidateOnOrderChange } from "../invaidateOnOrderChange";
import type { SavedOrder } from "../orderTypes";
import type { CreateOrderConfirmationRequest, OrderConfirmationResponse } from "../ordersApi";
import { createOrderConfirmation } from "../ordersApi";

export const useCreateOrderConfirmation = (order: Pick<SavedOrder, "id" | "start">) => {
  const queryClient = useQueryClient();
  const { enqueueSnackbar } = useSnackbar();

  const createConfirmationMutation = useMutation<OrderConfirmationResponse, unknown, CreateOrderConfirmationRequest>({
    mutationFn: (r) => createOrderConfirmation(order.id, r),
    onSuccess: async () => {
      enqueueSnackbar("Potwierdzenie zostało utworzone", {
        variant: "success",
      });
      await invalidateOnOrderChange(queryClient, order);
    },
    onError: (error) => {
      enqueueSnackbar(`Nie udało się utworzyć potwierdzenia. Powód: ${(error as Error).message}`, {
        variant: "error",
      });
    },
  });

  return {
    createConfirmation: (options: CreateOrderConfirmationRequest) => createConfirmationMutation.mutateAsync(options),
  };
};
